module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon8.36e8fbc6.svg";